export const baseUrl = 'https://cms-emmanuelle-margarita.acte.ltd'
